module.exports = __webpack_public_path__ + "img/input-plus.d7468a77.svg";